export default "__VITE_ASSET__DO4QP5HP__"